import store from 'dashboard/store';
import PatientOverviewHNGoalSetting from 'dashboard/templates/views/Patient/HN/PatientOverviewHNGoalSetting';

export default {
    path: 'goal-setting',
    name: 'PatientRecordHNGoalSetting',
    component: PatientOverviewHNGoalSetting,
    meta: {
        // title: 'Patient Record - Healthy Nutrition - Goal Setting',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        // title: 'Healthy Nutrition - Goal Setting',
        title: t => `${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        loggedInOnly: true,
        inSDMSessionOnly: true,
    },
    async beforeEnter(to, from, next) {
        const currentPatientId = from.params?.patientId;
        const newPatientId = to.params?.patientId;
    
        // Update user if back is used as everything stays cached in computed
        if ((currentPatientId === undefined && newPatientId) ||
            currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
        ) {
          await Promise.all([
            store.dispatch('patientSummary/get', newPatientId, {root: true}),
          ]);

          next();
        } else {
          next();
        }
      },
};